export const getUserPermissions = () => {
  const role = JSON.parse(sessionStorage.getItem("role"));
  // Extract abilities correctly
  const abilities = role ? role.abilities.map((item) => item.ability) : [];
  return abilities;
};
